import {FC, useState, createContext, useContext, useEffect} from 'react'
import {
  QueryState,
  QueryRequestContextProps,
  initialQueryRequest,
  WithChildren,
} from '../../../../../../_metronic/helpers'
import {useSearchParams} from 'react-router-dom'

const QueryRequestContext = createContext<QueryRequestContextProps>(initialQueryRequest)

const QueryRequestProvider: FC<WithChildren> = ({children}) => {
  const [searchParams, setSearchParams] = useSearchParams()
  const [state, setState] = useState<QueryState>({
    ...initialQueryRequest.state,
    filter: {
      status: 'Aberta',
      mode: searchParams.get('mode') ?? 'table',
      sort_by_delivery_date: true,
    },
  })

  const updateState = (updates: Partial<QueryState>) => {
    const updatedState = {...state, ...updates} as QueryState
    setState(updatedState)
  }

  useEffect(() => {
    const newParams = new URLSearchParams(searchParams)
    const mode = searchParams.get('mode')
    mode ? newParams.set('mode', mode) : newParams.set('mode', 'table')

    setSearchParams(newParams)
  }, [])

  return (
    <QueryRequestContext.Provider value={{state, updateState}}>
      {children}
    </QueryRequestContext.Provider>
  )
}

const useQueryRequest = () => useContext(QueryRequestContext)
export {QueryRequestProvider, useQueryRequest}
